import { render, staticRenderFns } from "./custom-p.vue?vue&type=template&id=d9706d12&"
import script from "./custom-p.vue?vue&type=script&lang=js&"
export * from "./custom-p.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports